import script from "./GaugeChart.vue?vue&type=script&setup=true&lang=js"
export * from "./GaugeChart.vue?vue&type=script&setup=true&lang=js"

import "./GaugeChart.vue?vue&type=style&index=0&id=1b1e5c21&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b1e5c21"]])

export default __exports__